import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice, syndicatedSource, checkStoryType } from '../../../helpers/utils';
import { trackCheckout } from '../../../helpers/datalayer-utils';
import PaytmIcon from '../../atoms/icons/paytm';
import SimplIcon from '../../atoms/icons/simpl';
import Loader from '../../atoms/icons/loader';
import MoengageHelper from '../../../helpers/moengage-helper';
import './micro-payment.m.css';

class PayNow extends React.Component {
  constructor(props) {
    super(props);
    this.pay = this.props.pay.bind(this);
    this.payWithSymbol = this.payWithSymbol.bind(this);
  }
  payWithSymbol() {
    global.Moengage &&
      MoengageHelper.walletLinkedStatusAttribute({ status: 'linked', name: 'Simpl' });
  }

  render() {
    const price = this.props.assetPlan
      ? formatPrice(
          this.props.assetPlan.price_cents / 100,
          this.props.assetPlan.price_currency,
          'en-IN',
          0
        )
      : '';
    const subscribeHeading = `Pay ${price} for this article`;
    const datalayerFields = {
      name: this.props.assetPlan.duration_unit,
      id: this.props.assetPlan.id,
      price: this.props.assetPlan.price_cents / 100,
      brand: this.props.story['story-template'] || 'text',
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
      dimension7: 'NA',
      dimension11: 'Logged In',
      dimension12: 'Banner',
      dimension13: 'Bottom Sticky',
      dimension14: 'NA',
      dimension15: `${this.props.story.headline}`,
      dimension16: this.props.story['story-template'] || 'text',
      dimension17: this.props.story['sections'][0].name,
      dimension18: 'NA',
      dimension19: this.props.story['author-name'],
      dimension20: (this.props.story.tags || []).map(t => t.name).join(' | '),
      dimension21: syndicatedSource(this.props.story)
    };
    return (
      <div styleName="story-subscribe-wrap">
        <div styleName="story-subscribe">
          <div styleName="align">
            <h3 styleName="subscribe-headline">{subscribeHeading}</h3>
            <p styleName="subscribe-summary">
              Once set-up, your future transactions using{' '}
              {this.props.selectedWallet === 'paytm' ? 'Paytm' : 'Simpl'} will require just
              two-clicks.
            </p>
            <div styleName="subscribe-buttons pay-now">
              <button
                styleName="paywall-button"
                onClick={() => {
                  trackCheckout(datalayerFields);
                  this.pay();
                  if (this.props.selectedWallet === 'simpl') {
                    this.payWithSymbol();
                  }
                }}
                disabled={this.props.isLoading}
              >
                {this.props.isLoading ? <Loader /> : `Pay ${price}`}
              </button>
              <div styleName="pay-now-price-wrap">
                <span styleName="input-icon">
                  {this.props.selectedWallet === 'paytm' && <PaytmIcon />}
                  {this.props.selectedWallet === 'simpl' && <SimplIcon />}
                </span>
              </div>
            </div>
            <span styleName="paywall-footer">
              {this.props.mobileNumber && (
                <span styleName="paywall-footer-mobile">{this.props.mobileNumber}</span>
              )}
              {this.props.paymentOptionsLength > 1 && (
                <span>
                  Change wallet?{' '}
                  <a onClick={this.props.changeWallet} styleName="paywall-footer-link">
                    Click here
                  </a>
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

PayNow.propTypes = {
  assetPlan: PropTypes.objectOf(PropTypes.any).isRequired,
  changeWallet: PropTypes.func.isRequired,
  selectedWallet: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string,
  pay: PropTypes.func.isRequired,
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool.isRequired,
  paymentOptionsLength: PropTypes.number
};

PayNow.defaultProps = {
  mobileNumber: ''
};

export default PayNow;
